import { vars } from "@imwebme/clay-token";
import { Heading } from "../../Heading";
import type { HeadingProps } from "../../Heading/Heading.types";

export const VisualModalHeader = (props: Omit<HeadingProps, "size" | "children" | "align">) => {
  return (
    <Heading
      align="center"
      size="large"
      sx={{
        paddingLeft: vars.spacing[6],
        paddingRight: vars.spacing[6],
      }}
      {...props}
    />
  );
};
